import { render } from "./ChatQuestionTemplateInput.vue?vue&type=template&id=5497efc8&scoped=true"
import script from "./ChatQuestionTemplateInput.vue?vue&type=script&lang=js"
export * from "./ChatQuestionTemplateInput.vue?vue&type=script&lang=js"

import "./ChatQuestionTemplateInput.vue?vue&type=style&index=0&id=5497efc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5497efc8"]])

export default __exports__